import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges, Output,
  EventEmitter  } from '@angular/core';
import {FormGroup,FormBuilder,Validators,FormArray} from '@angular/forms';
import{listadosService, LoopBackAuth, contactosService, validacionService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'lista-contactos',
  template: `
    <form name="form-inscripciones" [formGroup]="listaTelefonos">
    <div class="table-responsive">
      <table class="table">
        <thead>
            <tr>
                <th>Tipo</th>
                <th>Operadora</th>
                <th>Tipo</th>
                <th>Teléfono</th>
                <th>Ext</th>
                <th>Contacto</th>
                <th>Fav</th>
                <th>
                  <i
                    class="icofont icofont-plus-circle f-20 text-primary card-puntero"
                    [hidden] ="preview"
                    (click)="addFila(false)"></i>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of listaTelefonos.controls | search:1 ; let i = index;"
            [formGroupName]="i" >
                <td>
                    <div
                      class="input-group input-group-sm mb-0"
                      [ngClass]="{'showError': !item.get('etiqueta').valid && item.get('etiqueta').touched}">
                      <select
                      class="form-control"
                      formControlName="etiqueta"
                      >
                      <option *ngFor="let item of etiquetasTelefono" [value]="item.id">{{item.descripcion | uppercase}}</option>
                    </select>
                  </div>
                </td>
                <td>
                  <div
                  class="input-group input-group-sm mb-0"
                  [ngClass]="{'showError': !item.get('operadora').valid && item.get('operadora').touched}">
                    <select
                    class="form-control"
                    formControlName="operadora"
                    >
                    <option *ngFor="let item of operadorasTelefono" [value]="item.id">{{item.descripcion | uppercase}}</option>
                  </select>
                  </div>
                </td>
                <td>
                  <div
                    class="input-group input-group-sm mb-0"
                    [ngClass]="{'showError': !item.get('tipo').valid && item.get('tipo').touched}">
                      <select
                      class="form-control"
                      formControlName="tipo"
                      >
                      <option *ngFor="let item of tiposTelefono" [value]="item.id">{{item.descripcion | uppercase}}</option>
                    </select>
                  </div>
                </td>
                <td>
                  <div
                    class="input-group input-group-sm mb-0"
                    [ngClass]="{'showError': !item.get('numero').valid && item.get('numero').touched}">
                    <input
                        type="text"
                        class="form-control"
                        maxlength="13"
                        formControlName="numero"
                    >
                  </div>
                </td>
                <td>
                  <div
                    class="input-group input-group-sm mb-0"
                    [ngClass]="{'showError': !item.get('extencion').valid && item.get('extencion').touched}">
                    <input
                        type="text"
                        class="form-control"
                        formControlName="extencion"
                        frmUppercase
                    >
                  </div>
                </td>
                <td>
                  <div
                    class="input-group input-group-sm mb-0"
                    [ngClass]="{'showError': !item.get('contacto').valid && item.get('contacto').touched}">
                    <input
                        type="text"
                        class="form-control"
                        formControlName="contacto"
                        placeholder="Nombre,Parentesco"
                        frmUppercase
                    >
                  </div>
                </td>
                <td class="form-radio align-items-center">
                  <div class="radio radio-inline">
                    <label>
                    {{item.predeterminado}}
                    <input
                      type="radio"
                      name="favorito"
                      [disabled]="preview"
                      (change)="onFavorito(i)"
                      [checked]="item.get('predeterminado').value"
                      >
                    <i class="helper"></i>
                    </label>
                  </div>
                </td>
                <td>
                  <i
                    class="icofont icofont-ui-delete f-18 text-muted card-puntero"
                    [hidden]= "preview"
                    (click)="deleteFila(item, i)"></i>
                </td>
            </tr>
        </tbody>
      </table>
    </div>
  </form>

  `,
  styles: [],
  providers:[listadosService, LoopBackAuth, validacionService, contactosService, MessageService],

})
export class ListaContactosComponent implements OnInit, OnChanges {
  @Input() listaTelefonos : FormArray
  @Input() preview: boolean
  @Input() defaultEtiqueta: number = null
  @Input() addNumFila: number = 0
  @Input() idUsuario: null
  @Input() activarEtiquetas : boolean = true
  @Output() envioTelefonos  = new EventEmitter()

  etiquetasTelefono: any []
  operadorasTelefono: any []
  tiposTelefono: any []

  constructor(
    private fb: FormBuilder,
    private listadosService:listadosService,
    private toastr: ToastrService,
    private contactosService:contactosService,
    private val:validacionService)  { }

  ngOnInit() {
    this.listadosService.grupos('G_ETIQUETA_TELEFONO,G_OPERADORA_TELEFONO,G_TIPO_TELEFONO').subscribe(
        grupos =>{
          if(grupos != null){
            this.etiquetasTelefono = grupos['G_ETIQUETA_TELEFONO'].orden
            this.operadorasTelefono = grupos['G_OPERADORA_TELEFONO'].orden
            this.tiposTelefono = grupos['G_TIPO_TELEFONO'].orden
          }
        }
      )
  }

  limpiarContactos(){
    let telefonos =  this.listaTelefonos as FormArray
    for(let i=0 ; i < telefonos.length; i++){
      telefonos[i].removeAt()
    }
  }

  llenarContactos(lista, etiqueta){
    /** limpiar el arrglo para cargar la nueva informacion */
    //this.listaTelefonos = this.fb.array([])
    this.limpiarContactos()
    var telefonos = this.listaTelefonos as FormArray
     /** asigno alista de telefonos la informacion */
    for(let i=0 ; i < lista.length; i++){
      let item = lista[i]
      telefonos.push(
        this.fb.group({
          id:[item.id],
          etiqueta:[{value: item.etiqueta_glb_global_listado_id, disabled: etiqueta}],
          operadora:[item.operadora_glb_global_listado_id],
          tipo:[item.tipo_glb_global_listado_id],
          numero:[item.telefono],
          extencion:[item.extension],
          contacto:[item.contacto],
          predeterminado:[item.predeterminado],
          estado:[1],
          existe:[1]
        })
      )
    }
  }

  ngOnChanges(changes:SimpleChanges) {

    if(changes.preview !=undefined
      && changes.preview.currentValue != undefined && changes.preview.currentValue){
      this.onPreview()
    }
    if(changes.idUsuario !=undefined
        &&changes.idUsuario.currentValue != undefined){
          this.contactosService.findUsuarioId(this.idUsuario).subscribe(
            lista =>{
              if(lista != null){
                this.llenarContactos(lista, this.activarEtiquetas)
                if(lista.length == 0)  this.addFila(true)
              }
            }
          )
    }   
  }



  addFila(predeterminado):void{
    if(this.validaTelefonos()){
      let fila = this.getTelefono(predeterminado)
      let item = this.listaTelefonos as FormArray
      if(this.defaultEtiqueta != null)
        fila.get('etiqueta').disable()
      item.push(fila)

      this.envioTelefonos.emit();
    }
  }

  validaTelefonos(){
    let telefonos = this.listaTelefonos as FormArray
    let valTelefono = true
    for(let telefono of telefonos.controls){
      let aux  = telefono as FormGroup
      Object.keys(aux.controls).forEach(field =>{
        const control = telefono.get(field);

        if(!control.valid
            && control.value == null
            && telefono.get('estado').value == 1){
              valTelefono = false
              control.markAsTouched({ onlySelf: true })
            }
      })
    }
    return valTelefono
  }

  onPreview(){
    for(let i=0; i < this.listaTelefonos.controls.length ; i++){
      this.listaTelefonos.controls[i].disable()
    }
  }

  getTelefono(predeterminado){
    return this.fb.group({
      id:[null],
      etiqueta:[this.defaultEtiqueta, Validators.required],
      operadora:[null, Validators.required],
      tipo:[null, Validators.required],
      numero:[null, Validators.required],
      extencion:[null],
      contacto:[null],
      predeterminado:[predeterminado],
      estado:[1],
      existe:[0],
    })
  }
  
  deleteFila(item, index):void{
    //let telefonos = this.listaTelefonos as FormArray
    if(item.get('existe').value == 1 && !item.get('predeterminado').value){
      item.patchValue({
        estado:-99
      })
    }else if(!item.get('predeterminado').value){
      this.listaTelefonos.removeAt(index)
    }else{
      this.toastr.warning("No puede borrar, tiene como favorito", "Alerta")
    }

  }
 
  onFavorito(index):void{
    for(let i = 0; i < this.listaTelefonos.controls.length; i++ ){
      this.listaTelefonos.controls[i].patchValue({
        predeterminado: false
      })
    }
    this.listaTelefonos.controls[index].patchValue({
      predeterminado: true
    })
    console.log(this.listaTelefonos)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/lista-contactos.component.ts